import * as React from 'react';
import * as _ from 'lodash';

import * as DetailFormCommon from '../../inventory/detail-form/common';
import CopyAddressToClipboard from '../../common/copyaddresstoclipboard';
import { Formatters } from '../../common/formatters';

export const AssociationDetailsCopyAddress = ({ association, ...rest }) => {

    if (Formatters.getInt(association, 'associationId') <= 0) { return (<div/>); }

    let assocAddress: Array<string> = _.stubArray();
    if (_.has(association, 'location.city') || _.has(association, 'location.stateCode')) {
        if (Formatters.getStr(association, 'location.city')) { assocAddress.push(Formatters.getStr(association, 'location.city')); }
        if (Formatters.getStr(association, 'location.stateCode')) { assocAddress.push(Formatters.getStr(association, 'location.stateCode')); }
    }

    return (
        <div className="association-details-copy-address-wrapper">
            <div>
                <div><span className="association-details-association-name">{Formatters.getStr(association, 'name')}</span> <span className="association-details-association-id">({association.associationId})</span></div>
                <div><span className="association-details-association-address">{Formatters.composeLocationFullAddress(association.location)}</span></div>
                <div>{(_.has(association, 'location')) ? (<CopyAddressToClipboard locationObj={association.location} />) : (<div />)}</div>
            </div>

            <div {...rest} />
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/association/components/association-details-copy-address.tsx